// Import utilities
const { isEmpty, isDefined } = _uo.utility;

/**
 * Returns the action data
 *
 * @param {Number} itemID The item ID
 * @return {Object} The item
 */
const getItemAction = ( itemID ) => {
	return searchAction(
		UncannyAutomator._recipe.actions.items,
		itemID
	);
}

/**
 * Search for a specific actions inside a specific set of action items
 * This array could contain filters or loops too, so we create another function to search it recursively
 *
 * @param {Array} items The `UncannyAutomator._recipe.actions` items
 * @param {Number} itemID The action ID
 * @return {Object} The item or `undefined`, if not found
 */
const searchAction = ( items, itemID ) => {
	// Search the action inside the first layer of items
	return items.reduce( ( previousSearch, item ) => {
		// If we already found an item in the previous iteration, just return that one
		if ( ! isEmpty( previousSearch ) ) {
			return previousSearch;
		}

		// If it's an action and the ID matches, return the item
		if ( item.type === 'action' && item.id === itemID ) {
			return item;
		}

		// If it's not an action and has items inside, search them there
		if ( item.type !== 'action' && isDefined( item.items ) ) {
			return searchAction(
				item.items,
				itemID
			)
		}
	// eslint-disable-next-line no-undefined
	}, undefined );
}

export default getItemAction;
